import { gql } from '@apollo/client';

export const FETCH_SUB_ACCOUNT_BILLING_BREADCRUMB = gql`
  query fetchSubAccountBillingBreadcrumb(
    $input: FetchSubAccountBillingsInput!
  ) {
    fetchSubAccountBillings(input: $input) {
      subAccountBillings {
        id
        subAccount {
          id
          goal {
            id
            name
            type
          }
          account {
            id
            type
            user {
              id
              firstName
              lastName
            }
          }
        }
      }
    }
  }
`;
